/*
 * @Author: yeyimei
 * @Date: 2022-11-11 11:47:48
 * @LastEditTime: 2023-03-24 17:49:52
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\router\kfc.routes.js
 */
export default [
  {
    path: "/kfc/home",
    name: "kfcHome",
    component: () => import("@/views/kfc/home.vue"),
    meta: {
      title: "肯德基",
      showName: true,
    },
  },
  {
    path: "/kfc/store-list",
    name: "kfcStoreList",
    component: () => import("@/views/kfc/storeList.vue"),
    meta: {
      title: "肯德基",
    },
  },
  {
    path: "/kfc/order",
    name: "kfcOrder",
    component: () => import("@/views/kfc/order.vue"),
    meta: {
      title: "肯德基",
    },
  },
  {
    path: "/kfc/comfirm-pay",
    name: "kfcComfirmPay",
    component: () => import("@/views/kfc/confirmPay.vue"),
    meta: {
      title: "确认付款",
    },
  },
  {
    path: "/kfc/order-list",
    name: "kfcOrderList",
    component: () => import("@/views/kfc/orderList.vue"),
    meta: {
      title: "肯德基订单",
    },
  },
  {
    path: "/kfc/order-detail",
    name: "kfcOrderDetail",
    component: () => import("@/views/kfc/orderDetail.vue"),
    meta: {
      title: "肯德基订单详情",
    },
  },
  {
    path: "/kfc/order-notice",
    name: "kfcOrderNotice",
    component: () => import("@/views/kfc/orderNotice.vue"),
    meta: {
      title: "点餐须知",
    },
  },
]
